import React from 'react';
import { View } from 'react-native';
import { Svg, Path } from 'react-native-svg';

import { Color } from '~/components/color';

import { IconProps } from './icon-types';

export const CloseIcon = ({ fill, size = 24 }: IconProps) => {
    return (
        <View style={{ width: size, height: size }}>
            {/* @ts-ignore see https://github.com/react-native-svg/react-native-svg/issues/1471 */}
            <Svg accessibilityRole="image" viewBox="0 0 24 24" focusable={false} tabIndex="-1">
                <Path
                    d="M7 17.0001L17.0001 7"
                    stroke={fill ?? Color.ALMOST_BLACK}
                    strokeWidth="2"
                    // @ts-ignore
                    tabIndex="-1"
                />
                <Path
                    d="M6.99988 7L17 17.0001"
                    stroke={fill ?? Color.ALMOST_BLACK}
                    strokeWidth="2"
                    // @ts-ignore
                    tabIndex="-1"
                />
            </Svg>
        </View>
    );
};
